import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import CustomSubCP from "./CustomSubCP";

const Card = styled.div`
  border: "0";
  margin-bottom: 0px;
  margin-top: 8px;
  color: black;
  background: none;
  width: 100%;
  //position: relative;
  display: flex;
  flex-direction: column;
  word-wrap: "break-word";
  font-size: ".875rem";
  border-radius: 6px;
`;

function PlanActionsCard2(props) {
  return (
    <div>
      <Card collapse="xs">
        <CustomSubCP
          logo={props.logo}
          number={props.dataGroup}
          name={props.name}
        />
      </Card>
    </div>
  );
}

PlanActionsCard2.propTypes = {
  dataGroup: PropTypes.string,
  dataMeter: PropTypes.string,
  dataCounter: PropTypes.string,
  dataActive: PropTypes.string,
  dataInactive: PropTypes.string,
};

export default PlanActionsCard2;
